import styled from "styled-components";
import { responsive } from "../../../../../../../../styles/constants.style";

export const ProjectStatusResultWrapper = styled.div`
  margin: 16px 0px 16px 0px;
  ${responsive.MOBILE`
    margin: 0px 0px 0px 0px;
  `}
  .MuiPickersInputBase-root {
    width: 285px;
  }
`;
